<div class="co-dialog">
  <h2 mat-dialog-title>{{ title }}</h2>

  <mat-dialog-content>
    <div class="co-row">
      <mat-form-field appearance="outline" class="co-field co-field--wide" *ngIf="isAdd">
        <mat-label>Client name</mat-label>
        <input matInput [(ngModel)]="displayName" (ngModelChange)="onNameChange()" required />
      </mat-form-field>

      <mat-form-field appearance="outline" class="co-field">
        <mat-label>Domain</mat-label>
        <input matInput [(ngModel)]="domain" placeholder="acme.com" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="co-field">
        <mat-label>Salesforce ID</mat-label>
        <input matInput [(ngModel)]="salesforceId" />
      </mat-form-field>
    </div>
    <div class="co-hint">Domain and Salesforce ID are only sent to the Accounts Service when a new organization is created.</div>

    <div class="co-section">
      <strong>Enverus organization</strong>
      <span class="co-hint">Search by name, Salesforce ID or organization id, then pick one, or create a new organization.</span>
    </div>

    <mat-form-field appearance="outline" class="co-field co-field--full">
      <mat-label>Search organizations</mat-label>
      <input matInput [(ngModel)]="searchText" (ngModelChange)="onSearchChange()" placeholder="Type at least 3 characters…" />
    </mat-form-field>

    <mat-progress-bar *ngIf="searching" mode="indeterminate" class="co-progress"></mat-progress-bar>
    <div *ngIf="searchError" class="co-error">{{ searchError }}</div>

    <div class="co-results" role="radiogroup" aria-label="Enverus organization">
      <button type="button" *ngFor="let o of results"
              class="co-option"
              role="radio"
              [attr.aria-checked]="selected === o.organizationId"
              [class.co-option--selected]="selected === o.organizationId"
              [class.co-option--disabled]="!!o.linkedClientId"
              [disabled]="!!o.linkedClientId"
              (click)="select(o)">
        <span class="co-radio" aria-hidden="true"></span>
        <span class="co-option-body">
          <span class="co-option-name">
            {{ o.name }}
            <span *ngIf="isExactName(o) && !o.linkedClientId" class="co-tag co-tag--match">Exact name match</span>
            <span *ngIf="o.linkedClientId" class="co-tag">Linked to {{ o.linkedClientName }}</span>
          </span>
          <span class="co-option-id">{{ o.organizationId }}</span>
        </span>
      </button>

      <div *ngIf="searched && !searching && !searchError && results.length === 0" class="co-empty">
        No organizations match '{{ searchText.trim() }}'.
      </div>

      <button type="button"
              class="co-option co-option--new"
              role="radio"
              [attr.aria-checked]="selected === 'new'"
              [class.co-option--selected]="selected === 'new'"
              (click)="selectNew()">
        <span class="co-radio" aria-hidden="true"></span>
        <span class="co-option-body">
          <span class="co-option-name">+ Create new organization<ng-container *ngIf="newOrganizationName"> '{{ newOrganizationName }}'</ng-container></span>
          <span class="co-option-id">Only if this client is not already on the Enverus platform.</span>
        </span>
      </button>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="dialogRef.close()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]="!canSave" (click)="save()">
      {{ saving ? 'Saving…' : (isAdd ? 'Add client' : 'Link organization') }}
    </button>
  </mat-dialog-actions>
</div>
